var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { useHeaderEditor } from '@graphiql/react';
import React from 'react';
export function HeaderEditor(_a) {
  var active = _a.active,
    hookArgs = __rest(_a, ["active"]);
  var ref = useHeaderEditor(hookArgs);
  return React.createElement("div", {
    className: "codemirrorWrap",
    style: {
      position: active ? 'relative' : 'absolute',
      visibility: active ? 'visible' : 'hidden'
    },
    ref: ref
  });
}